import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef, useState } from 'react';
import { JoveButton, JoveTextFieldControlled } from '@jove-frontend/mui';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import { apiJoveRegister } from 'libs/uikit/src/api/combineApi';
import { REQUEST_SUCCESS_CODE } from 'libs/uikit/src/constants';
import { isPublishOnline } from 'libs/uikit/src/utils/common';
import { useFormContext } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { validateIsEmail } from '../../../../utils/formatValidate';
import { useLocalTranslation } from '../../../../utils/i18nKit';
import { TurnstileCaptcha, isTurnstileCaptchaEnabled } from '../../captcha';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * delay before the post-register success flow runs; the backend only creates role permissions
 * after the Auth0 post-registration callback fires, so the auto-login must give it time to complete
 */
var REGISTER_SUCCESS_AUTO_LOGIN_DELAY = 1500;

var SignUpForm = function SignUpForm(props) {
  var unregisteredEmailDetected = props.unregisteredEmailDetected,
      onRegister = props.onRegister,
      onLogIn = props.onLogIn;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var _useState = useState(false),
      submitting = _useState[0],
      setSubmitting = _useState[1];

  var _useState2 = useState(false),
      passwordVisible = _useState2[0],
      setPasswordVisible = _useState2[1];

  var _useState3 = useState(null),
      captchaToken = _useState3[0],
      setCaptchaToken = _useState3[1];

  var captchaRef = useRef(null);

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      handleSubmit = _useFormContext.handleSubmit,
      getValues = _useFormContext.getValues; // when no Turnstile site key is configured the captcha is inactive and must not block submission


  var captchaVerified = !isTurnstileCaptchaEnabled() || !!captchaToken;
  /**
   * request
   */

  var requestRegister = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _captchaRef$current;

      var _getValues, email, password, params, _yield$apiJoveRegiste, _yield$apiJoveRegiste2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getValues = getValues(), email = _getValues.email, password = _getValues.password;
              params = _objectSpread({
                email: email,
                password: password
              }, captchaToken ? {
                captcha_token: captchaToken
              } : {});
              setSubmitting(true);
              _context.next = 5;
              return apiJoveRegister(params);

            case 5:
              _yield$apiJoveRegiste = _context.sent;
              _yield$apiJoveRegiste2 = _slicedToArray(_yield$apiJoveRegiste, 1);
              res = _yield$apiJoveRegiste2[0];

              if (!((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE)) {
                _context.next = 15;
                break;
              }

              _context.next = 11;
              return new Promise(function (resolve) {
                return setTimeout(resolve, REGISTER_SUCCESS_AUTO_LOGIN_DELAY);
              });

            case 11:
              setSubmitting(false);
              toast === null || toast === void 0 ? void 0 : toast.success($t('text:login.account_created'));
              onRegister === null || onRegister === void 0 ? void 0 : onRegister();
              return _context.abrupt("return");

            case 15:
              // captcha tokens are single-use — reset the widget so the user can retry after a failed attempt
              (_captchaRef$current = captchaRef.current) === null || _captchaRef$current === void 0 ? void 0 : _captchaRef$current.reset();
              setSubmitting(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestRegister() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * methods
   */


  var continueAction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              handleSubmit(requestRegister)();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function continueAction() {
      return _ref2.apply(this, arguments);
    };
  }();

  var logInAction = function logInAction() {
    onLogIn === null || onLogIn === void 0 ? void 0 : onLogIn();
  };

  var togglePasswordVisibilityAction = function togglePasswordVisibilityAction() {
    setPasswordVisible(function (visible) {
      return !visible;
    });
  };

  var captchaVerifyAction = function captchaVerifyAction(token) {
    setCaptchaToken(token);
  };

  var passwordEndAdornment = /*#__PURE__*/_jsx(InputAdornment, {
    position: "end",
    children: /*#__PURE__*/_jsx(IconButton, {
      size: "small",
      edge: "end",
      "aria-label": "toggle password visibility",
      onClick: togglePasswordVisibilityAction,
      children: passwordVisible ? /*#__PURE__*/_jsx(VisibilityOff, {
        fontSize: "small"
      }) : /*#__PURE__*/_jsx(Visibility, {
        fontSize: "small"
      })
    })
  });

  var validateEmail = function validateEmail(value) {
    return validateIsEmail(value) ? true : $t('text:login.valid_email');
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col space-y-6",
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-2 text-center",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "h1",
        className: "text-3xl font-black text-[#202020] md:text-4xl",
        children: $t('text:login.welcome')
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-base text-gray-500",
        children: unregisteredEmailDetected ? $t('text:login.no_account_found') : $t('text:login.sign_up_to_continue')
      })]
    }), /*#__PURE__*/_jsx(JoveTextFieldControlled, {
      name: "email",
      control: control,
      rules: {
        validate: validateEmail
      },
      autoFocus: true,
      autoComplete: "email",
      label: $t('text:login.email_label'),
      placeholder: $t('text:login.email_placeholder')
    }), /*#__PURE__*/_jsx(JoveTextFieldControlled, {
      name: "password",
      control: control,
      rules: {
        required: $t('text:login.enter_password')
      },
      fullWidth: true,
      autoComplete: "new-password",
      type: passwordVisible ? 'text' : 'password',
      label: $t('text:login.password_label'),
      placeholder: $t('text:login.password_placeholder'),
      endAdornment: passwordEndAdornment
    }), !isPublishOnline() && /*#__PURE__*/_jsx(TurnstileCaptcha, {
      ref: captchaRef,
      onVerify: captchaVerifyAction
    }), /*#__PURE__*/_jsx(JoveButton, {
      variant: "contained",
      color: "primary",
      size: "large",
      loading: submitting,
      disabled: !captchaVerified,
      className: "w-full",
      onClick: continueAction,
      children: $t('text:login.sign_up')
    }), /*#__PURE__*/_jsxs(Typography, {
      className: "text-center text-sm text-gray-500",
      children: [$t('text:login.already_have_account'), ' ', /*#__PURE__*/_jsx(Typography, {
        component: "span",
        className: "cursor-pointer font-semibold text-[#CD0D47] hover:underline",
        onClick: logInAction,
        children: $t('text:login.log_in')
      })]
    })]
  });
};

export default SignUpForm;